<template>
    <div :key="valuekey">
        <div id="header" class="app-header" v-bind:class="{ 'app-header-inverse': appOptions.appHeaderInverse }">
            <div class="navbar-header">
                <button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarEndMobile" v-if="appOptions.appSidebarTwo">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <div class="navbar-brand">
                    <img class="navbar-brand-logo" :src="logoSrc" alt="ShieldGo" />
                </div>

                <button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile" v-if="appOptions.appTopMenu && appOptions.appSidebarNone">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>

                <button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarMobile" v-if="!appOptions.appSidebarNone">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
            </div>
            <div class="navbar-nav">
                <header-mega-menu v-if="appOptions.appHeaderMegaMenu"></header-mega-menu>
                <div class="navbar-item header-timezone-chip-wrapper d-none d-lg-flex" :title="accountTimezoneTooltip">
                    <span class="header-timezone-icon">
                        <i class="fa fa-clock"></i>
                    </span>
                    <span class="header-timezone-text">
                        <strong>{{ accountTimezoneGmt }}</strong>
                        <small>{{ accountTimezoneLabel }}</small>
                    </span>
                </div>

                <b-nav-item-dropdown class="navbar-item" menu-class="dropdown-menu media-list" right toggle-class="navbar-link dropdown-toggle icon" no-caret>
                    <template slot="button-content">
                        <i @click="handleEnableSound" class="fa fa-volume-up p-3" v-if="soundEnabled"></i>
                        <i @click="handleEnableSound" class="fa fa-volume-mute p-3" v-else></i>
                    </template>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown class="navbar-item" toggle-class="navbar-link dropdown-toggle" no-caret v-if="appOptions.appHeaderLanguageBar">
                    <template slot="button-content">
                        <span v-if="this.$i18n.locale === 'pt'">
                            <span class="flag-icon flag-icon-br me-1" title="br"></span>
                            <span class="name d-none d-sm-inline me-1">{{ $t('str.language.br') }}</span>
                        </span>
                        <span v-else-if="this.$i18n.locale === 'en'">
                            <span class="flag-icon flag-icon-us me-1" title="usa"></span>
                            <span class="name d-none d-sm-inline me-1">{{ $t('str.language.usa') }}</span>
                        </span>
                        <span v-else-if="this.$i18n.locale === 'es'">
                            <span class="flag-icon flag-icon-es me-1" title="es"></span>
                            <span class="name d-none d-sm-inline me-1">{{ $t('str.language.es') }}</span>
                        </span>
                        <b class="caret"></b>
                    </template>
                    <b-dropdown-item @click="changeLanguage('pt')"
                        ><span class="flag-icon flag-icon-br"></span> {{ isCurrentLanguage ? $t('str.language.portuguese.br') : $t('str.language.portuguese') }}</b-dropdown-item
                    >
                    <b-dropdown-item @click="changeLanguage('en')"
                        ><span class="flag-icon flag-icon-us"></span> {{ isCurrentLanguage ? $t('str.language.english.en') : $t('str.language.english') }}</b-dropdown-item
                    >
                    <b-dropdown-item @click="changeLanguage('es')"
                        ><span class="flag-icon flag-icon-es"></span> {{ isCurrentLanguage ? $t('str.language.spanish.es') : $t('str.language.spanish') }}</b-dropdown-item
                    >
                </b-nav-item-dropdown>
                <b-nav-item-dropdown right menu-class="me-1" class="navbar-item navbar-user dropdown" toggle-class="navbar-link dropdown-toggle d-flex align-items-center" no-caret>
                    <template slot="button-content">
                        <div class="image image-icon bg-gray-800 text-gray-600">
                            <img v-if="this.user?.photoURL && this.user.photoURL !== 'https://'" crossorigin="anonymous" class="profile-image" v-bind:src="`${domain}${this.user?.photoURL}`" alt="" />
                            <i v-else class="fa fa-user"></i>
                        </div>
                        <span class="d-none d-md-inline">{{ `${this.user?.firstName} ${this.user?.lastName}` }}</span>
                        <b class="caret"></b>
                    </template>
                    <a href="#/profile" class="dropdown-item">{{ $t('str.header.menu.edit.profile') }}</a>
                    <a href="#/change-password" class="dropdown-item">{{ $t('str.header.menu.change.password') }}</a>
                    <div class="dropdown-divider"></div>
                    <a href="#/" class="dropdown-item" v-on:click.prevent="logout">{{ $t('str.header.menu.signout') }} </a>
                </b-nav-item-dropdown>
                <div class="navbar-divider d-none d-md-block" v-if="appOptions.appSidebarTwo"></div>
                <div class="navbar-item d-none d-md-block" v-if="appOptions.appSidebarTwo">
                    <a href="javascript:;" v-on:click="toggleSidebarEnd" class="navbar-link icon">
                        <i class="fa fa-th"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue'
import Controller from './CrtHeader.vue'
import HeaderMegaMenu from './HeaderMegaMenu.vue'
import Common from '../../common/Common.vue'
import Vue from 'vue'
Vue.prototype.$registerEvent = new Vue()

export default {
    name: 'Header',
    components: {
        HeaderMegaMenu,
    },
    data() {
        return {
            appOptions: AppOptions,
            user: null,
            valuekey: 0,
            domain: null,
            soundEnabled: true,
            darkMode: false,
        }
    },
    computed: {
        logoSrc() {
            return this.darkMode ? require('../../assets/images/logo.png') : require('../../assets/images/logo-light.png')
        },
        accountTimezoneOption() {
            const timezone = Common.resolveTimezoneId(this.user?.accountTimezone || this.user?.account?.timezone || 'America/Sao_Paulo')
            return Common.buildTimezoneOption(timezone)
        },
        accountTimezoneGmt() {
            const fullName = this.accountTimezoneOption?.name || ''
            const match = fullName.match(/\((GMT[+-]\d{2}:\d{2})\)/)
            return match?.[1] || 'GMT-03:00'
        },
        accountTimezoneLabel() {
            const fullName = this.accountTimezoneOption?.name || ''
            return fullName.replace(/^\(GMT[+-]\d{2}:\d{2}\)\s*/, '') || 'America / Sao Paulo'
        },
        accountTimezoneTooltip() {
            const timezoneId = this.accountTimezoneOption?._id || 'America/Sao_Paulo'
            return `${this.accountTimezoneGmt} · ${timezoneId}`
        },
    },
    methods: Controller.methods,
    created() {
        const state = this

        state.$registerEvent.$on('updateHeader', function () {
            state.refreshUser(state)
        })

        state.$registerEvent.$on('setDarkMode', function (value) {
            state.darkMode = value
        })

        state.$registerEvent.$on('soundAlert', function () {
            Common.show(state, 'top-right', 'error', state.$t('msg.new.sos.notification'))

            if (!state.soundEnabled) return

            setTimeout(() => {
                var audio = new Audio(require('../../assets/sound/alarm.mp3'))
                audio.play().catch(() => {
                })
            }, 1000)
        })
    },
    mounted() {
        Controller.init(this)
    },
}
</script>
<style scoped>
.app-header .navbar-user img {
    height: 35px !important;
    width: max-content !important;
}

.app-header .navbar-header {
    justify-content: center;
}

.app-header .navbar-brand {
    margin-right: 0;
    margin-left: 0;
    padding: 0.25rem 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app-header .navbar-brand-logo {
    height: 52px;
    width: auto;
    max-height: none;
    display: block;
    margin: 0 auto;
    object-fit: contain;
}

.header-timezone-chip-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 34px;
    max-width: 220px;
    margin-right: 0.35rem;
    padding: 0.28rem 0.58rem;
    border-radius: 999px;
    border: 1px solid rgba(var(--app-header-color-rgb), 0.18);
    background: linear-gradient(120deg, rgba(var(--app-header-color-rgb), 0.07), rgba(var(--app-header-color-rgb), 0.13));
}

.header-timezone-icon {
    width: 21px;
    height: 21px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(var(--app-header-color-rgb), 0.16);
    color: var(--app-header-color);
    font-size: 0.64rem;
    flex: 0 0 auto;
}

.header-timezone-text {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.08rem;
    min-width: 0;
    color: var(--app-header-color);
}

.header-timezone-text strong {
    font-size: 0.72rem;
    line-height: 1;
    letter-spacing: 0.02em;
}

.header-timezone-text small {
    font-size: 0.62rem;
    line-height: 1.1;
    opacity: 0.8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.app-header-inverse .header-timezone-chip-wrapper {
    border-color: rgba(255, 255, 255, 0.34);
    background: linear-gradient(120deg, rgba(9, 21, 45, 0.56), rgba(13, 28, 57, 0.72));
}

.app-header-inverse .header-timezone-icon {
    background: rgba(255, 255, 255, 0.22);
    color: #ffffff;
}

.app-header-inverse .header-timezone-text {
    color: #ffffff;
}

@media (max-width: 767px) {
    .app-header .navbar-header {
        justify-content: space-between;
    }

    .app-header .navbar-brand-logo {
        height: 52px;
    }
}
</style>
